import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

const fetchAllAreas = async () => {
	const response = await cmsClient.get<CMSPaginatedData<Area>>("/store/area/");

	return response.data;
};
const useAreas = () => {
	const query = useQuery(["areas"], fetchAllAreas, { staleTime: 86400000 }); // cache for 24 hours

	return query;
};

export default useAreas;
